export const DEFAULT_DEBOUNCE_RATE = 1000

export function onKeyDown(validKeys: string[], cb: any): any {
  return function onKeyDownHandler(event: KeyboardEvent) {
    if (validKeys.includes(event.key) && typeof cb === 'function') {
      cb()
    }
  }
}
